import React from "react";

import { Check } from "react-feather";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  colors,
  makeStyles,
} from "@material-ui/core";

import { DrivingDetailsProps } from "../types";

const useStyles = makeStyles({
  check: {
    color: colors.green[500],
    height: 20,
    width: 20,
  },
});

const AdditionalDrivers: React.FC<Pick<
  DrivingDetailsProps,
  "additionalDrivers"
>> = ({ additionalDrivers = [] }) => {
  const classes = useStyles();

  return (
    <Table>
      <TableBody>
        {additionalDrivers &&
          additionalDrivers.map(driver => (
            <TableRow key={driver.id}>
              <TableCell colSpan={2}>Name</TableCell>
              <TableCell
                colSpan={3}
                data-test={`additional-driver-${driver.id}`}
              >
                {driver.name && driver.name.fullName}
              </TableCell>
              <TableCell align="right">
                <Check className={classes.check} />
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
};

export default AdditionalDrivers;
